
webpack.register(
    'blocks/usga/home-selection-tabs/home-selection-tabs',
    function() {
        return import('blocks/usga/home-selection-tabs/home-selection-tabs');
    },
    true
);